export const complectationAnchor = 'complectation-block-anchor';
